import enviro from 'enviro';
const GENERIC_OAUTH_APP_IDS = {
  QA: 44349652,
  PROD: 50112219
};
export const GENERIC_OAUTH_APP_ID = enviro.isQa() ? GENERIC_OAUTH_APP_IDS.QA : GENERIC_OAUTH_APP_IDS.PROD;

/**
 * The callback URL the customer must allow-list on their OAuth app in the
 * provider's developer portal. Resolves to the QA host in QA so an OAuth app
 * registered for testing redirects back to the QA redirect service.
 */
export const OAUTH_REDIRECT_URL = enviro.isQa() ? 'https://oauth-redirect.hubspotqa.com/callback' : 'https://oauth-redirect.hubspot.com/callback';